import type { AiExtraction } from '@/shared/ocr/ai-extraction';
import { AI_EXTRACTION_JOB_TYPES, AI_EXTRACTION_STATUSES } from '@/shared/ocr/ai-extraction';

export interface LlmParseJobOutput {
  mode: 'online_queue' | 'offline_skip';
  photoIds: string[];
  reason?: string;
}

export function createQueuedLlmParseJob(input: {
  createdAt: string;
  id: string;
  photoIds: string[];
  sessionId: string;
}): AiExtraction {
  const output: LlmParseJobOutput = {
    mode: 'online_queue',
    photoIds: input.photoIds,
  };

  return {
    createdAt: input.createdAt,
    id: input.id,
    jobType: AI_EXTRACTION_JOB_TYPES.geminiExtraction,
    output: output as unknown as Record<string, unknown>,
    sessionId: input.sessionId,
    status: AI_EXTRACTION_STATUSES.queued,
  };
}

export function createSkippedLlmParseJob(input: {
  createdAt: string;
  id: string;
  photoIds: string[];
  reason: string;
  sessionId: string;
}): AiExtraction {
  const output: LlmParseJobOutput = {
    mode: 'offline_skip',
    photoIds: input.photoIds,
    reason: input.reason,
  };

  return {
    completedAt: input.createdAt,
    createdAt: input.createdAt,
    id: input.id,
    jobType: AI_EXTRACTION_JOB_TYPES.geminiExtraction,
    output: output as unknown as Record<string, unknown>,
    sessionId: input.sessionId,
    status: AI_EXTRACTION_STATUSES.skipped,
  };
}
